import { BaseProfileModel } from '../index';
import { APP_PERMISSION } from '../../../../../../app/pages/authentication/authentication.config';

export class PremierProfileModel extends BaseProfileModel {
    constructor(profile) {
        super(profile);
        const userResponseInfo = profile.user;
        const PERM_GRANT = 'GRANT';
        const PERM_NONE = 'NONE';
        const userPermission = profile.permissions;

        this.firstName = userResponseInfo.firstName;
        this.lastName = userResponseInfo.lastName;
        this.emailAddress = userResponseInfo.email;
        this.contactPhoneNumber = userResponseInfo.phoneNumber;
        this.roles = userResponseInfo.role;
        this.userId = userResponseInfo.id;
        this.fans = [];

        /* App Market Permission*/
        const APPM_PERMISSIONS = ['buyAndManange', 'buy', 'manange'];
        const appmPermissionStatus = [userPermission.am_buy === PERM_GRANT &&
        userPermission.am_manage === PERM_GRANT, userPermission.am_buy === PERM_GRANT, userPermission.am_manage === PERM_GRANT];
        const amPermInd = appmPermissionStatus.indexOf(true);

        this.permission = amPermInd === -1 ? PERM_NONE : APP_PERMISSION[APPM_PERMISSIONS[amPermInd]];

        /* Device Track Permission*/
        const ADDP_PERMISSIONS = ['addp_viewOnly', 'addp_partialControl', 'addp_fullControl', 'addp_none'];
        const getADDPPermissions = ADDP_PERMISSIONS.map(i => profile.permissions[i]);
        const permInd = getADDPPermissions.indexOf('GRANT');

        this.addpAuthority = APP_PERMISSION[ADDP_PERMISSIONS[permInd === -1 ? 3 : permInd]];
        this.fanSignedUpStatus = 'SOME';

        this.impersonator = profile.impersonator;
        this.fanList = profile.fans || [];
        this.agreement = profile.agreement;
        if (profile.agreement && profile.agreement.fans) {
            for (let fan of profile.agreement.fans) {
            this.fans.push(fan);
            }
        }
    }
}